import { render, staticRenderFns } from "./DateDetails.vue?vue&type=template&id=3f33be38&scoped=true&"
import script from "./DateDetails.vue?vue&type=script&lang=js&"
export * from "./DateDetails.vue?vue&type=script&lang=js&"
import style0 from "./DateDetails.vue?vue&type=style&index=0&id=3f33be38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f33be38",
  null
  
)

export default component.exports